module.exports = __webpack_public_path__ + "static/media/5.ef50f70a.svg";